import styled from "styled-components";
import ReactFlow from "react-flow-renderer";

export const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
`;

export const Container = styled.div`
  position: absolute;
  top: 1.1rem;
  right: 1.75rem;
  display: flex;
  align-items: center;
  gap: 1rem;

  display: flex;
  z-index: 50;
`;

export const StatsButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.2rem;
  outline: none;
  border: none;
  background: #40e5a0;
  border-radius: 0.35296625rem;
  padding: 0.794375rem 1.765rem;
  box-shadow: 0px 0.235310625rem 0.8824125rem rgba(64, 229, 160, 0.41);
  cursor: pointer;
  svg {
    height: 0.9375rem;
  }

  span {
    font-size: 0.7062rem;
    font-family: Sora;
  }
`;

export const AddNoteButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  background: rgba(153, 255, 255, 1);
  border-radius: 0.35296625rem;
  padding: 0.794375rem 1.2rem;
  box-shadow: 0px 0.235310625rem 0.8824125rem rgba(153, 255, 255, 0.41);
  margin-right: 10px;
  cursor: pointer;
  svg {
    height: 0.9375rem;
  }

  span {
    margin-left: 0.43125rem;
    font-size: 0.7062rem;
    font-family: Sora;
  }
`;

export const MenuOptions = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  bottom: 1.5rem;
  right: 5rem;
  z-index: 30;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  padding: 2rem;
  background: #fff;
`;

export const FlowBoard = styled(ReactFlow)`
  position: relative;
  width: 100%;
  height: 100%;

  //Padrão ReactFlow
  line-height: 22.856px;
  font-size: 16px;

  cursor: ${({ paneMoving }) => (paneMoving ? "grabbing" : "grab")};

  .react-flow__edges {
    position: absolute;
    top: 0;
    left: 0;
    /* z-index: 3 !important; */
  }
  .react-flow__nodes {
    z-index: 3;
  }

  .react-flow_pane {
    z-index: auto;
  }

  .react-flow_background {
    z-index: auto;
    pointer-events: none;
  }
  .react-flow__handle-connecting {
    background: #ff6060;
  }

  .react-flow__handle-valid {
    background: #55dd99;
  }
  .non-interactable {
    pointer-events: none !important; //Para elementos totalmente gráficos
  }
  .flow_elements_edge {
    pointer-events: none !important;
  }
`;
